import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Megaphone, Check } from "lucide-react";

const fmtDateTime = (iso) => {
  try { return new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }); }
  catch { return iso; }
};

export function CommunicationDetailDialog({ open, onOpenChange, comm, onConfirm, confirming }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md max-h-[85vh] overflow-y-auto" data-testid="comm-detail-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-base">
            <Megaphone className="h-5 w-5 text-sky-600" /> Comunicazione dall'Ufficio
          </DialogTitle>
        </DialogHeader>
        {comm && (
          <div className="space-y-3">
            <p className="text-xs text-slate-500">
              {comm.context}{comm.datetime ? ` · ${fmtDateTime(comm.datetime)}` : ""}
            </p>
            <p className="text-sm text-slate-800 whitespace-pre-wrap" data-testid="comm-detail-body">{comm.body}</p>
            {comm.read_at && (
              <p className="text-[11px] text-emerald-600 font-semibold flex items-center gap-1">
                <Check className="h-3.5 w-3.5" /> Letto il {fmtDateTime(comm.read_at)}
              </p>
            )}
            {onConfirm && (
              <Button data-testid="comm-confirm-read" disabled={confirming} onClick={onConfirm}
                className="w-full rounded-lg bg-[#22364D] hover:bg-[#2f4a6b] text-white">
                <Check className="h-4 w-4 mr-2" /> {confirming ? "Salvataggio…" : "Ho letto quanto comunicato"}
              </Button>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default CommunicationDetailDialog;
